import axios, {AxiosResponse} from 'axios'

// Get all users
const getUsers = async ({params}) => {
  const response = await axios.get('/api/user/list', params)
  return response.data
}

// Create new user
const createUser = async ({user}) => {
  await axios.post('/api/user/store', user)
}

// Get user by id
const getUserById = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/user/edit/${id}`)
  return response.data
}

// Update user
const updateUser = async ({user}) => {
  await axios.post('/api/user/update', user)
}

// Delete user
const deleteUser = async (user_id: string) => {
  await axios.post(`/api/user/destroy/${user_id}`)
}

// Update user password
const updateUserPassword = async ({data}) => {
  const response = await axios.post('/api/user/change-password', data)
  return response.data
}

const getLecturerUsers = async ({params}) => {
  const response = await axios.get('/api/user/lecturer-list', params)
  return response.data
}

const getStduentUsers = async ({params}) => {
  const response = await axios.get('/api/user/student-users-list', params)
  return response.data
}

const setUserLanguage = async (lang: string) => {
  const response = await axios.get(`/api/user/set-lang/${lang}`)
  return response.data
}

const setCampus = async ({user}) => {
  const res = await axios.post('/api/select-campus', user)
  return res.data
}

const userService = {
  setCampus,
  setUserLanguage,
  getStduentUsers,
  getLecturerUsers,
  getUsers,
  createUser,
  getUserById,
  updateUser,
  deleteUser,
  updateUserPassword,
}

export default userService
